import { defineStore } from "pinia";
import { MapState, MapScreenshotInfo } from "@/types/projectTypes";

export const useMapStateStore = defineStore("mapState", {
  state: (): MapState => ({
    center: {
      lat: 45.52461486997845,
      lng: 10.215663848808767,
    },
    zoom: 13,
    screenshot_info: null,
  }),

  actions: {
    updateMapState(center: { lat: number; lng: number }, zoom: number) {
      this.center = center;
      this.zoom = zoom;
    },

    setScreenshotInfo(info: MapScreenshotInfo) {
      this.screenshot_info = info;
      console.log("[MapState] Screenshot info saved to store");
    },

    clearMapState() {
      this.$patch({
        center: {
          lat: 45.52461486997845,
          lng: 10.215663848808767,
        },
        zoom: 13,
        screenshot_info: null,
      });
      console.log("[MapState] Map state cleared");
    },
  },
});
